// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AllData, AllErrors, AllResponses, CompleteUploadData, CompleteUploadErrors, CompleteUploadResponses, CreateJobData, CreateJobErrors, CreateJobResponses, CreateRunData, CreateRunErrors, CreateRunResponses, DeleteEmployeeData, DeleteEmployeeErrors, DeleteEmployeeResponses, GetLatestSuccessfulRunData, GetLatestSuccessfulRunErrors, GetLatestSuccessfulRunResponses, HealthData, HealthErrors, HealthResponses, OneData, OneErrors, OneResponses, PresignUploadData, PresignUploadErrors, PresignUploadResponses, ReplaceEmployeeData, ReplaceEmployeeErrors, ReplaceEmployeeResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const deleteEmployee = <ThrowOnError extends boolean = false>(options: Options<DeleteEmployeeData, ThrowOnError>) => (options.client ?? client).delete<DeleteEmployeeResponses, DeleteEmployeeErrors, ThrowOnError>({ url: '/jobs/{id}', ...options });

export const one = <ThrowOnError extends boolean = false>(options: Options<OneData, ThrowOnError>) => (options.client ?? client).get<OneResponses, OneErrors, ThrowOnError>({ url: '/jobs/{id}', ...options });

export const replaceEmployee = <ThrowOnError extends boolean = false>(options: Options<ReplaceEmployeeData, ThrowOnError>) => (options.client ?? client).put<ReplaceEmployeeResponses, ReplaceEmployeeErrors, ThrowOnError>({
    url: '/jobs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const presignUpload = <ThrowOnError extends boolean = false>(options: Options<PresignUploadData, ThrowOnError>) => (options.client ?? client).post<PresignUploadResponses, PresignUploadErrors, ThrowOnError>({
    url: '/uploads/presign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const completeUpload = <ThrowOnError extends boolean = false>(options: Options<CompleteUploadData, ThrowOnError>) => (options.client ?? client).post<CompleteUploadResponses, CompleteUploadErrors, ThrowOnError>({
    url: '/uploads/complete-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createRun = <ThrowOnError extends boolean = false>(options: Options<CreateRunData, ThrowOnError>) => (options.client ?? client).post<CreateRunResponses, CreateRunErrors, ThrowOnError>({
    url: '/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const all = <ThrowOnError extends boolean = false>(options?: Options<AllData, ThrowOnError>) => (options?.client ?? client).get<AllResponses, AllErrors, ThrowOnError>({ url: '/jobs', ...options });

export const createJob = <ThrowOnError extends boolean = false>(options: Options<CreateJobData, ThrowOnError>) => (options.client ?? client).post<CreateJobResponses, CreateJobErrors, ThrowOnError>({
    url: '/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getLatestSuccessfulRun = <ThrowOnError extends boolean = false>(options: Options<GetLatestSuccessfulRunData, ThrowOnError>) => (options.client ?? client).get<GetLatestSuccessfulRunResponses, GetLatestSuccessfulRunErrors, ThrowOnError>({ url: '/jobs/result/{jobId}', ...options });

export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: '/health', ...options });
